import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "edit-profile" }
const _hoisted_3 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexEdit',
  setup(__props) {

const userProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/userProfile.vue"))
const editProfile = defineAsyncComponent(() => import("@/components/theme/user/edit/editProfile.vue"))
const userTable = defineAsyncComponent(() => import("@/components/theme/user/edit/userTable.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "User",
      title: "Edit Profile"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(userProfile)),
          _createVNode(_unref(editProfile)),
          _createVNode(_unref(userTable))
        ])
      ])
    ])
  ], 64))
}
}

})